
    import { defineComponent, type PropType, onMounted, ref } from 'vue'

    import type { VWindow } from '@/@types/vuetify'
    import { useVuetify } from '@/common/composables/libs/vuetify'
    import type { Slide } from '@/common/models/data/dashboard/slides'

    export default defineComponent({
        props: {
            slides: {
                type: Array as PropType<Array<Slide>>,
                required: true
            }
        },
        setup () {
            const vuetify = useVuetify()

            const currentSlide = ref(0)
            const slideTimeout = ref<number | undefined>()
            const slidesWindow = ref<VWindow>()

            const imageUrl = (entry: Slide): string => {
                if (entry.mobile_image && vuetify.breakpoint.smAndDown) {
                    return entry.mobile_image
                }

                return entry.image
            }

            const isLinkAbsolute = (link: string | undefined): boolean => {
                return link !== undefined && (link.startsWith('http') || link.startsWith('https'))
            }

            const onSlideChange = (): void => {
                slideTimeout.value && window.clearTimeout(slideTimeout.value)
                slideTimeout.value = undefined

                window.requestAnimationFrame(startTimeout)
            }

            const startTimeout = (): void => {
                if (!slidesWindow.value) {
                    return
                }

                slideTimeout.value = window.setTimeout(slidesWindow.value.next, 6000)
            }

            onMounted((): void => startTimeout())

            return {
                currentSlide,
                slidesWindow,
                imageUrl,
                isLinkAbsolute,
                onSlideChange,
                startTimeout
            }
        }
    })
